<template>
  <div>

     <div v-if="loading">
        <b-spinner variant="primary" style="width: 3rem; height: 3rem;" label="Large Spinner"></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <h3 class="mb-3">{{ role.name }}</h3>

        <p class="text-muted font-size-13 mb-1">Permissions</p>
        <span v-for="item in role.permissions" :key="item.id">
          - {{ item.name }}
          <br />
        </span>

        <p class="text-muted font-size-13 mb-1 mt-3">Id</p>
        <p class="mb-3">{{ role.id }}</p>

        <p class="text-muted font-size-13 mb-1 mt-3">Created On</p>
        <p
          class="mb-3 text-body"
        >{{ moment(new Date(role.created_at)).format("DD MMM YYYY, HH:mm:ss") }}</p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import roleRepo from "@/api/repos/roleRepo";

export default {
  props: ["id"],

  mounted() {
    this.getRole();
  },

  data() {
    return {
      loading:false,
      role: {
        name: "",
        permissions: []
      }
    };
  },

  methods: {
    async getRole() {
      try {
        this.loading = true
        let { data } = await roleRepo.get(this.id);
        this.role = data.role;
        this.role.permissions = data.role.permissions;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false
      }
    }
  }
};
</script>
